// src/helpers/chatHelper.js
const SOCKET_EVENTS = {
    MESSAGE_UPDATED: 'message:updated',
    MESSAGE_SEND: 'message:send',
    MESSAGE_RECEIVED: 'message:received',
    MESSAGE_REMOVED: 'message:removed',
    MESSAGE_COMPOSE_SEND: 'message:compose:send',
    MESSAGE_COMPOSE_RECEIVED: 'message:compose:receive',
    MESSAGE_ACKNOWLEDGE_READ_RECEIVED: 'message:acknowledge:read:received',
    MESSAGE_ACKNOWLEDGE_DELIVERED: 'message:acknowledge:delivered',
    MESSAGE_NOTIFY_UNREAD_RECEIVED: 'message:notify:unread:send',
    MESSAGE_NOTIFY_UNREAD_SENT: 'message:notify:unread:received',
    MESSAGE_ACKNOWLEDGE_READ_SEND: 'message:acknowledge:read:send',
};

export default { SOCKET_EVENTS };
